import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useSlots } from 'vue';
import DocIcon from '@/components/ui/icons/DocIcon.vue';

enum ButtonTheme {
  PRIMARY = 'primary',
  GHOST = 'ghost',
  OUTLINE = 'outline',
}

enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DocButton',
  props: {
    theme: { default: 'primary' as ButtonTheme },
    size: { default: 'small' as ButtonSize },
    href: { default: '' },
    to: { default: '' },
    icon: { default: '' },
    isInvisible: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as { theme: ButtonTheme, size: ButtonSize, href: string, to: string | object, icon: string, isInvisible: boolean };





const slots = useSlots();
const hoverState = ref(false);

const hasDefaultSlot = computed(() => Boolean(slots.default));

const computedClass = computed(() => ({
  'doc-button_primary': props.theme === ButtonTheme.PRIMARY,
  'doc-button_ghost': props.theme === ButtonTheme.GHOST,
  'doc-button_outline': props.theme === ButtonTheme.OUTLINE,

  'doc-button_small': props.size === ButtonSize.SMALL,
  'doc-button_medium': props.size === ButtonSize.MEDIUM,
  'doc-button_large': props.size === ButtonSize.LARGE,

  'doc-button_with-icon': props.icon && slots.default,
  'doc-button_icon-only': props.icon && !slots.default,
}));

const computedTag = computed(() => {
  if (props.href) return 'a';
  if (props.to) return 'router-link';
  return 'button';
});

return { __sfc: true,ButtonTheme, ButtonSize, props, slots, hoverState, hasDefaultSlot, computedClass, computedTag, DocIcon }
}

})